import React from 'react'
import { Card, CardBody, CardHeader, Col } from 'reactstrap';
import { Skeleton } from '@mui/material';

function SkeletonLoader(colSizeMd?: string, colSize?: string) {
    const skeletonLength = 25;

    return (
        Array.from({ length: skeletonLength }).map((val, index) => {
            return <Col xl={colSize ? colSize : "6"} md={colSizeMd ? colSizeMd : "2"} key={index} >
                <Card >
                    <CardHeader>
                        <Skeleton></Skeleton>
                    </CardHeader>
                    <CardBody >
                        <div >
                            <Skeleton></Skeleton>
                        </div>
                    </CardBody>
                </Card>
            </Col>
        })
    )
}

export default SkeletonLoader
